import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import Hamburger from "../../Icons/Hamburger/Hamburger";

// Define pages as objects with title + url
const pages = [
  { title: "Portfolio", url: "/portfolio" },
  { title: "Upcoming Events", url: "/upcoming-events" },
  { title: "Previous Events", url: "/previous-events" },
  { title: "Example Workshops", url: "/example-workshops" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // Get current path

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const isActive = (url) => location.pathname === url;

  return (
    <>
      <div className={styles.navbar}>
        <div className={styles.toolbar}>
          <Link to="/" className={styles.header}>
            <h1>Wheatear Strawcraft</h1>
          </Link>

          {/* Mobile Hamburger Menu */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <Hamburger open={menuOpen} onToggle={setMenuOpen} />
          </Box>

          {/* Desktop Links */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
            {pages.map((page) => (
              <Link
                to={page.url}
                key={page.title}
                className={`${styles.navButton} ${
                  isActive(page.url) ? styles.active : ""
                }`}
              >
                {page.title}
              </Link>
            ))}
          </Box>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className={styles.menu}>
          {pages.map((page) => (
            <Link
              key={page.title}
              to={page.url}
              onClick={handleCloseMenu}
              className={`${styles.navButton}`}
            >
              {page.title}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
